import React from 'react';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import MyPageSidebar from '@/features/mypage/components/MyPageSidebar';

import CSSModule from './MyPageTemplate2.module.scss';

interface Props {
  children?: React.ReactNode;
}

const MyPageTemplate2: React.FC<Props> = ({ children }) => (
  <SingleColumnTemplate>
    <div className={CSSModule.MyPageTemplate2}>
      <div className={CSSModule.MyPageTemplate2__MobileOnlyPageTitle}>
        <div className={CSSModule.MyPageTemplate2__MobileOnlyPageTitleInner}>
          <h1>アカウント設定</h1>
        </div>
      </div>
      <div className={CSSModule.MyPageTemplate2__Body}>
        <div className={CSSModule.MyPageTemplate2__PcOnlySidebar}>
          <MyPageSidebar />
        </div>
        <div className={CSSModule.MyPageTemplate2__Content}>{children}</div>
      </div>
    </div>
  </SingleColumnTemplate>
);

export default MyPageTemplate2;
